import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../atoms/atoms";
import { useCookies } from "react-cookie";
import { Toast } from "primereact/toast";
import {
    Autocomplete,
    Box,
    Chip,
    Grid,
    TextField,
    Typography,
    Paper,
    styled,
    FormControl,
    InputLabel,
    IconButton,
    Switch,
    SwitchProps,
    FormControlLabel,
    Checkbox,
    Tooltip
} from "@mui/material";
import {
    PersonOutlineOutlined,
    BusinessOutlined,
    TouchAppOutlined,
    InfoOutlined,
    CalendarMonthOutlined,
    LayersOutlined,
    CloseOutlined,
    AssignmentOutlined,
    FileDownloadOutlined,
    SettingsOutlined,
    PlaylistRemoveOutlined,
    CallToAction,
    CallToActionOutlined,
    PlaylistAddOutlined
} from "@mui/icons-material";
import Rmodal from "../../../../components/Rmodal";
import { Button, Divider } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import GridTemplate from "../../../../components/GridTemplate";
import { CustomerListType, LogType, UserType, AccessType, SelectedParametersType } from "../../../../types/types";
import logFindAllListResponse from "../../../../resources/Api/log/logFindAllListResponse";
import customerFindAllListResponse from "../../../../resources/Api/customer/customerFindAllListResponse";
import findAllAcessesByCustomer from "../../../../resources/Api/accesses/findAllAcessesByCustomer";
import dayjs from "dayjs";
import { PROFILE_ACESSES } from "../../../../consts/consts";

const logActions = [
    { value: "INSERT", label: "Inserção" },
    { value: "UPDATE", label: "Alteração" },
    // { value: "DELETE", label: "Exclusão" },
    { value: "DEACTIVATE", label: "Desativação" },
    { value: "ACTIVATE", label: "Ativação" },
    { value: "LOGIN", label: "Login" },
    { value: "LOGOUT", label: "Logout" },
    { value: "LOGIN_FAILED", label: "Falha de Login" },
    { value: "COMMAND_SENT", label: "Comando Enviado" },
    { value: "IMPERSONATE", label: "Personificação" },
    { value: "PASSWORD_CHANGED", label: "Senha Alterada" },
    { value: "PASSWORD_RECOVERY", label: "Recuperação de Senha" },
    { value: "EMAIL_CHANGED", label: "E-mail Alterado" },
    { value: "CUSTOMER_TRANSFER", label: "Transferência entre Clientes" },
];

const logEntities = [
    { value: "logs", label: "Logs do Sistema" },
    // { value: "municipios", label: "Municípios" },
    // { value: "motoristas_cnhcategoria", label: "Categorias de CNH" },
    { value: "tc_commands", label: "Comandos" },
    // { value: "paises", label: "Países" },
    { value: "clientes", label: "Clientes" },
    // { value: "perfis_acesso", label: "Perfis de Acesso" },
    { value: "clientes_parametros", label: "Parâmetros do Cliente" },
    { value: "departamentos", label: "Departamentos" },
    { value: "tc_devices", label: "Dispositivos" },
    // { value: "tc_device_geofence", label: "Dispositivos cercas" },
    // { value: "fabricantes_dispositivos", label: "Fabricantes de Dispositivos" },
    // { value: "protocolos", label: "Protocolos" },
    { value: "tc_drivers", label: "Motoristas" },
    // { value: "tc_events", label: "Eventos" },
    { value: "tc_notifications", label: "Comandos automáticos" },
    { value: "tc_geofences", label: "Cercas virtuais" },
    { value: "grupos_cercas", label: "Cerca e grupo" },
    { value: "grupos", label: "Grupos" },
    { value: "atendimentos", label: "Atendimentos (Chamados)" },
    { value: "atendimento_anexos", label: "Atendimento e anexos" },
    // { value: "atendimento_gravidades", label: "Gravidades de Atendimento" },
    { value: "atendimento_justificativas", label: "Atendimento e justificativas" },
    // { value: "atendimento_tipos", label: "Tipos de Atendimento" },
    { value: "identificadores", label: "Identificadores" },
    // { value: "menus", label: "Menus" },
    // { value: "menus_itens", label: "Itens de Menu" },
    // { value: "permissoes", label: "Permissões" },
    { value: "secretarias", label: "Secretarias" },
    { value: "usuarios", label: "Usuários" },
    // { value: "usuarios_perfis", label: "Usuários e perfis" },
    { value: "departamentos_usuarios", label: "Usuário e departamentos" },
    { value: "permissoes_usuarios", label: "Usuário e permissões" },
    { value: "secretarias_usuarios", label: "Usuário e secretarias" },
    { value: "grupos_usuarios", label: "Usuário e grupos" },
    { value: "veiculos", label: "Veículos" },
    // { value: "marcas_veiculos", label: "Marcas de Veículos" },
    // { value: "cores_veiculos", label: "Cores de Veículos" },
    // { value: "motoristas_veiculos", label: "Motoristas de Veículos" },
    { value: "grupos_veiculos", label: "Grupo e veículos" },
    // { value: "modelos_veiculos", label: "Modelos de Veículos" },
    // { value: "tipos_veiculos", label: "Tipos de Veículos" },
    // { value: "administradoras", label: "Administradoras" },
    { value: "veiculo_dispositivos", label: "Veículo e dispositivos" },
    // { value: "checagem_status", label: "Status de Checagem" },
    // { value: "checagem_tipos", label: "Tipos de Checagem" },
    { value: "checagens", label: "Checagens (Check-lists)" },
    //{ value: "veiculo_checagens", label: "Veículo e checagens (Relações)" },
    { value: "checagem_anexos", label: "Checagem e anexos" },
    { value: "tc_commands_queue", label: "Fila de Comandos" },
];

const internalLogUserIds = new Set([1, 8]);
const standardLogActions = new Set(["LOGIN", "LOGOUT", "IMPERSONATE", "PASSWORD_CHANGED"]);

const columns: GridColDef[] = [
    {
        field: "id",
        headerName: "ID",
        width: 80,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="ID"
            />
        ),
        renderCell: (params) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={params.value}
            />
        )
    },
    {
        field: "createdAt",
        headerName: "Data/Hora",
        width: 180,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Data/Hora"
                icon={<CalendarMonthOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={dayjs(params.value).format("DD/MM/YYYY HH:mm:ss")}
            />
        )
    },
    {
        field: "customerName",
        headerName: "Cliente",
        width: 200,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Cliente"
                icon={<BusinessOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={params.value || params.row.customerId || "-"}
            />
        )
    },
    {
        field: "insertUserId",
        headerName: "ID Usuário",
        width: 100,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="ID Usuário"
            />
        ),
        renderCell: (params) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={params.value || "-"}
            />
        )
    },
    {
        field: "userName",
        headerName: "Usuário",
        width: 200,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Usuário"
                icon={<PersonOutlineOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => (
            <Chip
                sx={{ background: "transparent", fontFamily: "Prometo" }}
                label={params.value || "-"}
            />
        )
    },
    {
        field: "action",
        headerName: "Ação",
        width: 180,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Ação"
                icon={<TouchAppOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => {
            const action = logActions.find(a => a.value === params.value);
            return (
                <Chip
                    label={action ? action.label : params.value}
                    sx={{
                        background: "rgba(0, 183, 0, 0.2)",
                        color: "#00B700",
                        fontFamily: "Prometo",
                        fontWeight: "bold"
                    }}
                />
            );
        }
    },
    {
        field: "entityName",
        headerName: "Entidade",
        width: 180,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Entidade"
                icon={<LayersOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => {
            const entity = logEntities.find(e => e.value === params.value);
            return (
                <Chip
                    sx={{ background: "transparent", fontFamily: "Prometo" }}
                    label={entity ? entity.label : params.value}
                />
            );
        }
    },
    {
        field: "previousContent",
        headerName: "Conteúdo Anterior",
        width: 200,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Antigo"
                icon={<InfoOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => (
            <Typography sx={{ color: "rgba(0, 0, 0, 0.5)", fontFamily: "Prometo", fontSize: "12px", whiteSpace: "normal", px: 1 }}>
                {params.value}
            </Typography>
        )
    },
    {
        field: "content",
        headerName: "Conteúdo Atual",
        flex: 1,
        minWidth: 300,
        renderHeader: () => (
            <Chip
                sx={{ color: "#fff", background: "transparent", fontFamily: "Prometo" }}
                label="Novo"
                icon={<InfoOutlined style={{ fill: "#fff" }} />}
            />
        ),
        renderCell: (params) => (
            <Typography sx={{ color: "black", fontFamily: "Prometo", fontSize: "13px", whiteSpace: "normal", px: 1 }}>
                {params.value}
            </Typography>
        )
    }
];

const LogListComponent = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const isDeveloper = getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DEVELOPER);

    const [cookies] = useCookies(["token", "selectedParameters"]);
    const toastRef = useRef<Toast>(null);

    const [loading, setLoading] = useState(false);
    const [logsList, setLogsList] = useState<LogType[]>([]);
    const [customersList, setCustomersList] = useState<CustomerListType[]>([]);
    const [usersList, setUsersList] = useState<AccessType[]>([]);

    // Filter states
    const [selectedCustomer, setSelectedCustomer] = useState<CustomerListType | null>(null);
    const [isTechnical, setIsTechnical] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<AccessType | null>(null);
    const [selectedAction, setSelectedAction] = useState<{ value: string, label: string } | null>(null);
    const [selectedEntity, setSelectedEntity] = useState<{ value: string, label: string } | null>(null);
    const [userStatus, setUserStatus] = useState<"activated" | "deactivated">("activated");
    const [localSearch, setLocalSearch] = useState("");

    // Modal state
    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const [selectedLog, setSelectedLog] = useState<LogType | null>(null);

    // Pagination states
    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const availableLogActions = useMemo(
        () => isDeveloper ? logActions : logActions.filter((action) => standardLogActions.has(action.value)),
        [isDeveloper]
    );

    // Customizable filters toggle state
    const [visibleFilters, setVisibleFilters] = useState(() => {
        const saved = localStorage.getItem("gtr_visible_logs_filters");
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch (e) {
                // ignore
            }
        }
        return {
            action: false
        };
    });

    const handleCloseDetails = () => {
        setIsOpenDetails(false);
        setSelectedLog(null);
        setIsTechnical(false);
    };

    useEffect(() => {
        localStorage.setItem("gtr_visible_logs_filters", JSON.stringify(visibleFilters));
    }, [visibleFilters]);

    const handleCheckboxChange = useCallback((filterKey: keyof typeof visibleFilters) => {
        setVisibleFilters((prev: any) => ({
            ...prev,
            [filterKey]: !prev[filterKey]
        }));
    }, []);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    })), []);

    const customHeaderOptions = useMemo(() => {
        return (
            <Box className="tw-relative tw-h-[45px] tw-w-[140px] tw-flex-none">
                <Box
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row-reverse",
                        width: "45px",
                        height: "45px",
                        overflow: "hidden",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        borderRadius: "25px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        "&:hover, &:focus-within": {
                            width: "140px",
                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                            paddingRight: "5px",
                        },
                        "&:hover .options-container, &:focus-within .options-container": {
                            opacity: 1,
                            transform: "translateX(0)",
                        }
                    }}
                >
                    <Tooltip title="Configurar filtros" arrow>
                    <IconButton
                        aria-label="Configurar filtros"
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            color: "#ffff",
                            minWidth: "45px",
                            height: "45px",
                        }}
                    >
                        <SettingsOutlined />
                    </IconButton>
                    </Tooltip>

                    <Box
                        className="options-container"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            opacity: 0,
                            transform: "translateX(20px)",
                            transition: "all 0.3s ease-out",
                            paddingRight: "10px",
                            whiteSpace: "nowrap"
                        }}
                    >
                        <Tooltip title="Filtro de ações" arrow>
                        <IconButton
                            onClick={() => { handleCheckboxChange("action") }}
                            aria-label="Filtro de ações"
                            sx={{
                                background: "#00b700",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <CallToActionOutlined style={{ color: "#ffff", fontSize: "1.1rem" }} />
                        </IconButton>
                        </Tooltip>

                        <Tooltip title={userStatus === "activated" ? "Você está visualizando ativos, clique para ver os usuários inativos" : "Você está visualizando inativos, clique para ver os usuários ativos"} arrow>
                        <IconButton
                            onClick={() => { setUserStatus(userStatus === "activated" ? "deactivated" : "activated") }}
                            aria-label={userStatus === "activated" ? "Mostrar usuários inativos" : "Mostrar usuários ativos"}
                            sx={{
                                background: userStatus === "activated" ? "#00b700" : "rgba(220, 53, 69, 1)",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            {userStatus === "activated" ? <PlaylistAddOutlined style={{ color: "#ffff", fontSize: "1.1rem" }} /> : <PlaylistRemoveOutlined style={{ color: "#ffff", fontSize: "1.1rem" }} />}
                        </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
        );
    }, [visibleFilters, handleCheckboxChange, userStatus]);

    const getCustomers = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, currentParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }
    }, [cookies.token, currentParameters.customer.id]);

    const getUsers = useCallback(async (customerId: number, type: string = "customer", status: string = "activated") => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await findAllAcessesByCustomer(
                token,
                customerId,
                1,
                type,
                status,
                0,
                100
            );
            setUsersList(data.content.filter((user: AccessType) => !internalLogUserIds.has(Number(user.id))));
        } catch (error) {
            console.error("Error fetching users:", error);
            setUsersList([]);
        }
    }, [cookies.token]);

    const formatSimplifiedLog = useCallback((content: string | null) => {
        if (!content) return "-";
        if (isTechnical) return content;

        // Tenta limpar e formatar strings técnicas complexas
        try {
            const parts = content.split(";").filter(p => p.trim() !== "");
            const simplified = parts.map(part => {
                const eqIndex = part.indexOf("=");
                if (eqIndex === -1) return part;

                const key = part.substring(0, eqIndex).trim();
                const value = part.substring(eqIndex + 1).trim();

                // Pula campos puramente técnicos se não estiver em modo técnico
                if (["id", "insertUserId", "customerId", "createdAt", "updatedAt", "version"].includes(key)) {
                    return null;
                }

                const label = key.replace(/([A-Z])/g, ' $1').toLowerCase();
                const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1);

                // Trata DataMappers: Entidade(id=X, name='Y', description='Z')
                if (value.includes("DataMapper(")) {
                    const descMatch = value.match(/description='([^']+)'/);
                    const nameMatch = value.match(/name='([^']+)'/);
                    const idMatch = value.match(/id=([^,)]+)/);

                    const cleanLabel = key.replace("_id", "").replace(/([A-Z])/g, ' $1').toLowerCase();
                    const finalLabel = cleanLabel.charAt(0).toUpperCase() + cleanLabel.slice(1);

                    if (descMatch && descMatch[1].trim() !== "" && descMatch[1].trim() !== "null") {
                        return `${finalLabel}: ${descMatch[1]}`;
                    } else if (nameMatch && nameMatch[1].trim() !== "" && nameMatch[1].trim() !== "null") {
                        return `${finalLabel}: ${nameMatch[1]}`;
                    } else if (idMatch) {
                        return `${finalLabel}: ${idMatch[1]}`;
                    }
                }

                if (key.toLowerCase().includes("_id")) {
                    const idMatch = value.match(/id=([^,)]+)/);
                    if (idMatch) {
                        return `${capitalizedLabel}: ${idMatch[1]}`;
                    }
                }

                // Formatação básica de camelCase para Label amigável
                return `${capitalizedLabel}: ${value}`;
            }).filter(Boolean);

            return simplified.length > 0 ? simplified.join("\n") : content;
        } catch (e) {
            return content;
        }
    }, [isTechnical]);

    const getLogs = useCallback(async (p: number = 0, s: number = 100) => {
        const token = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await logFindAllListResponse(
                token,
                selectedUser?.id || null,
                selectedCustomer?.id || null,
                selectedAction?.value || null,
                selectedEntity?.value || null,
                p,
                s
            );

            setLogsList(data.content);
            setIsLastPage(data.last);
            setNumberOfElementsPerPage(data.numberOfElements);
            setPageNumber(data.pageable.pageNumber);

            if (data.first) {
                setNumberOfElements(data.totalElements);
            }
        } catch (error: any) {
            console.error("Error fetching logs:", error);
            setLogsList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token, selectedUser, selectedCustomer, selectedAction, selectedEntity]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager) {
            getCustomers();
        }
    }, [getCurrentUser.configs.isManager, getCustomers]);

    useEffect(() => {
        if (selectedCustomer) {
            getUsers(selectedCustomer.id, "customer", userStatus);
            setSelectedUser(null);
            setSelectedAction(null);
            setSelectedEntity(null);
        } else {
            if (getCurrentUser.configs.isManager) {
                getUsers(getCurrentUser.customer.id, "manager", userStatus);
            } else {
                getUsers(getCurrentUser.customer.id, "customer", userStatus);
            }
            setSelectedUser(null);
            setSelectedAction(null);
            setSelectedEntity(null);
        }
    }, [selectedCustomer, getUsers, getCurrentUser.configs.isManager, getCurrentUser.customer.id, userStatus]);

    const filteredLogsList = useMemo(() => {
        if (!localSearch.trim()) return logsList;
        const search = localSearch.toLowerCase();
        return logsList.filter(log =>
            (log.content?.toLowerCase() || "").includes(search) ||
            (log.previousContent?.toLowerCase() || "").includes(search)
        );
    }, [logsList, localSearch]);

    useEffect(() => {
        getLogs();
    }, [getLogs]);

    const filtersContent = (
        <Box
            className="log-filter-grid tw-grid tw-w-full tw-grid-cols-1 tw-gap-x-3"
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(auto-fit, minmax(220px, 1fr))" },
                alignItems: "start",
                width: "100%",
                margin: 0,
                padding: 0,
            }}
        >
            {getCurrentUser.configs.isManager && (
                <Box className="tw-min-w-0" style={{ marginBottom: 10, marginTop: 10 }}>
                    <Autocomplete
                        options={customersList}
                        getOptionLabel={(option) => option.reducedName || option.name}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        noOptionsText={"Nada encontrado"}
                        value={selectedCustomer}
                        onChange={(_, newValue) => setSelectedCustomer(newValue)}
                        style={{
                            width: "100%",
                            minHeight: "56px",
                            height: "56px",
                            backgroundColor: "#ffffff29",
                            borderColor: "lightgray",
                        }}
                        renderInput={(params) => (
                            <FormControl className="form-group" style={{ display: "flex" }}>
                                <InputLabel shrink style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}>
                                    Cliente
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um cliente"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Cliente",
                                        classes: { notchedOutline: "custom-notch" }
                                    }}
                                />
                            </FormControl>
                        )}
                    />
                </Box>
            )}

            <Box className="tw-min-w-0" style={{ marginBottom: 10, marginTop: 10 }}>
                <Autocomplete
                    options={usersList}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    noOptionsText={"Nada encontrado"}
                    value={selectedUser}
                    onChange={(_, newValue) => setSelectedUser(newValue)}
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    renderInput={(params) => (
                        <FormControl className="form-group" style={{ display: "flex" }}>
                            <InputLabel shrink style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}>
                                Usuário
                            </InputLabel>
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Selecione um usuário"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    ...params.InputProps,
                                    notched: true,
                                    label: "Usuário",
                                    classes: { notchedOutline: "custom-notch" }
                                }}
                            />
                        </FormControl>
                    )}
                />
            </Box>

            {visibleFilters.action && (
                <Box className="tw-min-w-0" style={{ marginBottom: 10, marginTop: 10 }}>
                    <Autocomplete
                        options={availableLogActions}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        noOptionsText={"Nada encontrado"}
                        value={selectedAction}
                        onChange={(_, newValue) => setSelectedAction(newValue)}
                        style={{
                            width: "100%",
                            minHeight: "56px",
                            height: "56px",
                            backgroundColor: "#ffffff29",
                            borderColor: "lightgray",
                        }}
                        renderInput={(params) => (
                            <FormControl className="form-group" style={{ display: "flex" }}>
                                <InputLabel shrink style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}>
                                    Ação
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione uma ação"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Ação",
                                        classes: { notchedOutline: "custom-notch" }
                                    }}
                                />
                            </FormControl>
                        )}
                    />
                </Box>
            )}

            {isDeveloper && (
                <Box className="tw-min-w-0" style={{ marginBottom: 10, marginTop: 10 }}>
                    <Autocomplete
                        options={logEntities}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        noOptionsText={"Nada encontrado"}
                        value={selectedEntity}
                        onChange={(_, newValue) => setSelectedEntity(newValue)}
                        style={{
                            width: "100%",
                            minHeight: "56px",
                            height: "56px",
                            backgroundColor: "#ffffff29",
                            borderColor: "lightgray",
                        }}
                        renderInput={(params) => (
                            <FormControl className="form-group" style={{ display: "flex" }}>
                                <InputLabel shrink style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}>
                                    Entidade
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione uma entidade"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Entidade",
                                        classes: { notchedOutline: "custom-notch" }
                                    }}
                                />
                            </FormControl>
                        )}
                    />
                </Box>
            )}
        </Box>
    );

    const exportLogToCSV = useCallback(() => {
        if (!selectedLog) return;

        const actionLabel = logActions.find(a => a.value === selectedLog.action)?.label || selectedLog.action;
        const entityLabel = logEntities.find(e => e.value === selectedLog.entityName)?.label || selectedLog.entityName;

        const headers = ["ID", "Data/Hora", "Cliente", "Usuário", "Ação", "Entidade", "Conteúdo Anterior", "Conteúdo Atual"];
        const rowData = [
            selectedLog.id,
            dayjs(selectedLog.createdAt).format("DD/MM/YYYY HH:mm:ss"),
            selectedLog.customerName || selectedLog.customerId,
            selectedLog.userName || selectedLog.insertUserId,
            actionLabel,
            entityLabel,
            (selectedLog.previousContent || "").replace(/"/g, '""'),
            (selectedLog.content || "").replace(/"/g, '""')
        ];

        const csvContent = "\uFEFF" + [
            headers.join(";"),
            rowData.map(cell => `"${cell}"`).join(";")
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `log_auditoria_${selectedLog.id}_${dayjs().format("YYYYMMDD")}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, [selectedLog]);

    const DetailsModal = useMemo(() => (
        <Rmodal
            open={isOpenDetails}
            handleClose={() => setIsOpenDetails(false)}
        >
            <Paper className="log-details-modal tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-none tw-transition-all tw-duration-300 tw-ease-gtr-smooth sm:tw-p-6" elevation={0} sx={stylePaper}>
                <Box className="log-details-header" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontFamily: "Prometo",
                                fontWeight: "bold",
                                color: "#003f4a",
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <AssignmentOutlined sx={{ mr: 1 }} /> Detalhes do Log
                        </Typography>
                        {getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DEVELOPER) && <FormControlLabel
                            control={<IOSSwitch checked={isTechnical} onChange={(e) => setIsTechnical(e.target.checked)} />}
                            label={
                                <Typography sx={{ marginLeft: '5px', fontFamily: "Prometo", fontSize: "14px", fontWeight: "bold", color: isTechnical ? "#003f4a" : "#666" }}>
                                    Modo desenvolvedor
                                </Typography>
                            }
                            sx={{ ml: 2 }}
                        />}
                    </Box>
                    <Tooltip title="Fechar" arrow>
                        <IconButton aria-label="Fechar detalhes do log" onClick={handleCloseDetails} sx={{ color: "#d32f2f" }}>
                            <CloseOutlined />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Grid className="log-details-grid" container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>ID do Registro</Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Prometo", fontWeight: 500 }}>#{selectedLog?.id || "-"}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Data e Hora</Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Prometo", fontWeight: 500 }}>
                            {selectedLog?.createdAt ? dayjs(selectedLog.createdAt).format("DD/MM/YYYY HH:mm:ss") : "-"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Ação</Typography>
                        <Box sx={{ mt: 0.5 }}>
                            <Chip
                                label={(logActions.find(a => a.value === selectedLog?.action)?.label || selectedLog?.action) || "-"}
                                sx={{ bgcolor: "rgba(0, 183, 0, 0.2)", color: "#00B700", fontWeight: "bold", fontFamily: "Prometo" }}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Entidade</Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Prometo", fontWeight: 500 }}>
                            {(logEntities.find(e => e.value === selectedLog?.entityName)?.label || selectedLog?.entityName) || "-"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Usuário Responsável</Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Prometo", fontWeight: 500 }}>
                            {selectedLog?.userName ? `${selectedLog.userName} (ID: ${selectedLog.insertUserId || "-"})` : (selectedLog?.insertUserId ? `ID: ${selectedLog.insertUserId}` : "-")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Cliente</Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Prometo", fontWeight: 500 }}>
                            {selectedLog?.customerName ? `${selectedLog.customerName} (ID: ${selectedLog.customerId || "-"})` : (selectedLog?.customerId ? `ID: ${selectedLog.customerId}` : "-")}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Conteúdo Anterior</Typography>
                        <Paper className="log-content-surface" sx={{ p: 2, bgcolor: "#fff", mt: 1, borderRadius: 1, border: "1px solid #ddd", boxShadow: "none" }}>
                            <Typography variant="body2" sx={{ fontFamily: isTechnical ? "monospace" : "Prometo", whiteSpace: "pre-wrap", color: "#666", fontSize: "12px" }}>
                                {formatSimplifiedLog(selectedLog?.previousContent || null)}
                            </Typography>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" sx={{ fontFamily: "Prometo" }}>Novo Conteúdo (Atualização)</Typography>
                        <Paper className="log-content-surface" sx={{ p: 2, bgcolor: "#fff", mt: 1, borderRadius: 1, border: "1px solid #003f4a", boxShadow: "none" }}>
                            <Typography variant="body2" sx={{ fontFamily: isTechnical ? "monospace" : "Prometo", whiteSpace: "pre-wrap", color: "#003f4a", fontWeight: "bold", fontSize: "12px" }}>
                                {formatSimplifiedLog(selectedLog?.content || null)}
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                <Box className="log-details-actions tw-flex tw-flex-col-reverse tw-justify-end tw-gap-2 tw-border-t tw-border-black/10 tw-pt-4 sm:tw-flex-row" sx={{ mt: 4, pt: 2, display: "flex", flexDirection: { xs: "column-reverse", sm: "row" }, justifyContent: "flex-end", gap: 1, borderTop: "1px solid rgba(0,0,0,0.10)" }}>
                    <Button
                        variant="contained"
                        onClick={exportLogToCSV}
                        className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                    >
                        <FileDownloadOutlined sx={{ marginRight: 1 }} />
                        Exportar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleCloseDetails}
                        className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                    >
                        <CloseOutlined sx={{ marginRight: 1 }} />
                        Fechar
                    </Button>
                </Box>
            </Paper>
        </Rmodal>
    ), [isOpenDetails, selectedLog, exportLogToCSV, IOSSwitch, formatSimplifiedLog, getCurrentUser.accessProfile.id, isTechnical]);

    return (
        <>
            <Toast ref={toastRef} />
            {DetailsModal}

            <GridTemplate
                headerName="Logs do Sistema"
                columns={columns}
                rows={filteredLogsList}
                isLoading={loading}
                totalElements={numberOfElements}
                currentPage={pageNumber}
                totalPerPage={numberOfElementsPerPage}
                isLastPage={isLastPage}
                handleNext={(_status: any, p: number, s: number) => getLogs(p, s)}
                handlePrevious={() => { }}
                onRefresh={getLogs}
                onClickRow={(item: any) => {
                    setSelectedLog(item);
                    setIsOpenDetails(true);
                }}
                onExport={async () => { }}
                onAdd={() => { }}
                withOptions={false}
                withFilter={true}
                query={localSearch}
                setQuery={setLocalSearch}
                filterPlaceholder={"Filtrar nesta página..."}
                sortField="id"
                order="desc"
                isHiddenMenu={false}
                contentHeight={"520px"}
                containerHeight="auto"
                withCustomerParameter={true}
                customerParameter={filtersContent}
                customHeaderOptions={customHeaderOptions}
            />
        </>
    );
};

const stylePaper = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1000px)" },
    maxWidth: 1000,
    maxHeight: "calc(100dvh - 24px)",
    overflowY: "auto",
    transform: "translate(-50%, -50%)",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: { xs: 2, sm: 3 },
    fontFamily: "Prometo",
};

export default LogListComponent;
